import { api } from "./axios";
import { axiosApp } from "./axiosApp";

export const createFeedbackApi = async (feedbackData) => {
    try {
        const res = await axiosApp.post('/feedback/create', feedbackData);
        return res.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const fetchAllFeedbacksApi = async () => {
    try {
        const res = await axiosApp.get('/feedback');
        return res.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const updateFeedbackApi = async (feedbackId, feedbackData) => {
    try {
        const res = await axiosApp.put(`/feedback/${feedbackId}`, feedbackData);
        return res.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const deleteFeedbackApi = async (feedbackId) => {
    try {
        const res = await axiosApp.delete(`/feedback/${feedbackId}`);
        return res.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
